@use '@lib/assets/styles/main.scss' as *;

.closeButton {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 16px;
}
